import React, {Component} from 'react';
import {Grid, Button, Form, Message, Label,Checkbox, Dimmer, Loader, Divider} from 'semantic-ui-react';
import {NavLink} from 'react-router-dom';
import ContactUsTemplate from './ContactUsMailTemplate';
import GoogleReCaptcha from '../../widget/GoogleReCaptcha';
import Banner from "../../widget/PageBanner";
import ContactUsDetails from './ContactUsDetails.js';
import '../../assets/css/contactus.css';

import {contactUsScript} from '../../assets/js/contact-us/';
import { CONFIG } from '../../config.js';


const tourOptions = [
	{
		key: 0,
		value: 'customizedTour',
		text: 'I want to customize my tour',
	},
	{
		key: 1,
		value: 'tourBalkan',
	  	text: 'Eastern of Europe and The Balkans',
	},
	{
		key: 2,
	  	value: 'tourNZ',
	  	text: 'New Zealand',
	},
	{
		key: 3,
	  	value: 'tourHolyLand',
	  	text: 'Holy Land and Pilgrimage',
	},
	{
		key: 4,
	  	value: 'tourIcelandSummer',
	  	text: 'Iceland - Summer Edition',
	},
	{
		key: 5,
		value: 'tourIcelandWinter',
		text: 'Iceland - Aurora Winter Edition',
	},
	{
		key: 6,
	  	value: 'tourCANY',
	  	text: 'Eastern Canada and New York',
	},
	{
		key: 7,
	  	value: 'tourAfrica',
	  	text: 'South Africa',
	},
	{
		key: 8,
	  	value: 'tourBaltic',
	  	text: 'The Highlights of Baltic',
	},
	{
		key: 9,
	  	value: 'tourLatinAmerica',
	  	text: 'Best of Latin America',
	},
	{
		key: 10,
	  	value: 'tourCanadianRockies',
	  	text: 'The Canadian Rockies',
	},
	{
		key: 11,
	  	value: 'tourWinterNorway',
	  	text: 'Winter in Norway and Northern Lights',
	},
	{
		key: 12,
	  	value: 'tourTurkey',
	  	text: 'Turkey (Seven Churches of Revelations)',
	},
	{
		key: 13,
	  	value: 'tourRwandaAndUganda',
	  	text: 'Rwanda and Uganda',
	},
	{
		key: 14,
	  	value: 'tourWinterTurkey',
	  	text: 'Turkey',
	}
]



export default class ContactUs extends Component{
	constructor(props){
		super(props);
		
		this.state = contactUsScript.initState();
	}

	componentDidMount = () =>{
		this.setState({loading: true});
		this.setState({loading: false});
	}
	
	handleReCaptchaCallback = (data) => {
		this.setState(contactUsScript.reCaptchaCallback(data));
		this.recaptchaInstance = data.recaptchaInstance;
	}
	
	doSubmit = e => {
		e && e.preventDefault();

		this.setState({
			body: ContactUsTemplate(this.state)
		}, () => {
			contactUsScript.sendEmail(this, this.state, this.recaptchaInstance);
		});
	}
	
	render(){
		let {
			success,
			disableSubmit,
			errorMsg,
			tourPackageMsgError,
			customizedTour,
			name,
			nameMsgError,
			contactNumber,
			contactNumberMsgError,
			emailAddress,
			emailAdMsgError,
			message,
			messageMsgError,
			termsOfAgreement,
			termsErrorMsg,
			disableCaptcha,
			showCaptchaError
		} = this.state;
		
		return (
			<>
				 <div className="half-banner-wrapper">
					<Banner pagename="ContactUs"/>
				</div>
				<div className="section-content-wrapper">
					{/*<ContactUsDetails/>*/}
					<Grid className="contact-us-wrapper" >
						<Grid.Column width={8}>
							<Form method="POST" id="contact-form" className="ui form" onSubmit={this.doSubmit}>
							<Dimmer active = {this.state.loading} inverted>
								<Loader inverted content='Loading' />
							</Dimmer>
								<Grid>
									<Grid.Column width={16} className='contact-us-form'>
										<div className="subsection-gray-second">
											{(success && !disableSubmit) &&
												<Message positive>
													<Message.Header>Inquiry sent!</Message.Header>
													<p>You have successfully sent your inquiry</p>
												</Message>
											}
											<div className='error-wrapper'>
												{errorMsg !== '' && <Message negative>
													<Message.Header>Error</Message.Header>
													<p>{errorMsg}</p>
												</Message>}
											</div>
											<Form.Field>
												<Form.Dropdown
													onChange={e => this.setState(contactUsScript.setTourPackage(e.target.textContent))}
													placeholder='Select tour' 
													fluid selection 
													options={tourOptions} 
													label='Tour Package'
													error={(tourPackageMsgError != null && tourPackageMsgError !== '')}
													required
												/>
												{(tourPackageMsgError != null && tourPackageMsgError !== '') && <Label basic color='red' pointing>{tourPackageMsgError}</Label>}
											</Form.Field>
													
											{this.state.tourPackage === 'I want to customize my tour' &&
												<Form.Field>
													<Form.TextArea
														autoComplete="off"
														value={customizedTour}
														onChange={e => this.setState(contactUsScript.setCustomizedTour(e.target.value))}
														label='I want to go to'
														name='customizedTour'
														placeholder='I want to go to...'
														required
													/>
												</Form.Field>
											}
											<Form.Field>
												<Form.Input
													autoComplete="off"
													label='Name'
													name='name'
													value={name}
													onChange={e => this.setState(contactUsScript.setName(e.target.value))}
													maxLength={CONFIG.NAME_LENGTH}
													placeholder="Full name"
													required
													error={(nameMsgError !== '')}
												/>
												{nameMsgError !== '' && <Label basic color='red' pointing>{nameMsgError}</Label>}
											</Form.Field>
											<Form.Field>
												<Form.Input
													autoComplete="off"
													maxLength={CONFIG.MOBILE_LENGTH}
													value={contactNumber}
													onChange={e => this.setState(contactUsScript.setContactNumber(e.target.value))}
													label='Contact number'
													name='contactNumber'
													placeholder="Contact number"
													required
													error={(contactNumberMsgError !== '')}
												/>
												{contactNumberMsgError !== '' && <Label basic color='red' pointing>{contactNumberMsgError}</Label>}
											</Form.Field>
											<Form.Field>
												<Form.Input
													autoComplete="off"
													maxLength={CONFIG.EMAIL_LENGTH}
													value={emailAddress}
													onChange={e => this.setState(contactUsScript.setEmailAddress(e.target.value))}
													required
													type='email'
													label='Email address' name='emailAd' placeholder="E-mail address" 
													error={(emailAdMsgError !== '')}
												/>
												{emailAdMsgError !== '' && <Label basic color='red' pointing>{emailAdMsgError}</Label>}
											</Form.Field>
											<Form.Field>
												<Form.TextArea
													autoComplete="off"
													value={message}
													onChange={e => this.setState(contactUsScript.setMessage(e.target.value))}
													label='Message'
													name='message'
													placeholder="Enter your message here"
													required
													error={(messageMsgError !== '')}
												/>
												{messageMsgError !== '' && <Label basic color='red' pointing>{messageMsgError}</Label>}
											</Form.Field>
											
											<Form.Field className="check-terms-wrapper">
												<Checkbox className="check-terms"
													type='checkbox'
													checked={termsOfAgreement}
													onChange={e => this.setState(contactUsScript.setTermsOfAgreement(!termsOfAgreement))}
												/>	
												<label>
													<p> I/We have read, understood and given my/our consent for <span className="bold">Light Miles Travel</span> to collect, use and disclose my/our personal data in accordance
														to the <NavLink className="highlight-red" to="/dataprivacy" target="_blank"><span>Privacy Declaration</span></NavLink> given.
													</p>
													
												</label>
												{termsErrorMsg !== '' && <Label basic color='red' pointing>{termsErrorMsg}</Label>}
											</Form.Field>	
											<div className="captcha-wrapper">
												{!disableCaptcha &&
													<GoogleReCaptcha
														callbackFromParent={this.handleReCaptchaCallback}
														showCaptchaError={showCaptchaError}
													/>
												}
											</div>
											<div className="button-wrapper-right">
												<Button color="orange" className="btn-submit" positive content='Submit' name='btnSubmit' />
											</div>
										</div>
										<Divider className="contact-divider"></Divider>
									</Grid.Column>
								</Grid>
							</Form>
						</Grid.Column>
						<Grid.Column width={8}>

							<ContactUsDetails/>
						</Grid.Column>	
					</Grid>
				</div>
			</>
		);
	}
}
